import React, { Component } from 'react'
import Card from '@material-ui/core/Card'
import { Grid, Row, Col } from 'react-flexbox-grid'
import Divider from '@material-ui/core/Divider'

import { localize } from '../../util/Localizer'

class ProvidersResultCard extends Component {
  handleClick = () => {
    const { providerData, onClick } = this.props
    onClick(providerData)
  }
  render () {
    const { providerData } = this.props
    const distanceInKm = (providerData.distance / 1000).toFixed(1)
    const phoneNumber = (providerData.phone || 'N/A')
    const phoneNumberLink = `tel:${phoneNumber.replace(/[^0-9+]/g, '')}`
    return (
      <Card className='providersResultCard' onClick={this.handleClick}>
        <Grid fluid>
          <Row style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Col className='practitioner' xs={9}>
              <Row>
                {providerData.serviceType !== 'Drug' && <Col className='practitioner' lg={9}>
                  {localize('pages.providers.search.results.card.practitioner')}
                  <strong>{providerData.practionerName || 'N/A'}</strong>
                </Col>}
                <Col className='provider' lg={12}>
                  {localize('pages.providers.search.results.card.provider')}
                  <strong>{providerData.name}</strong>
                </Col>
              </Row>
            </Col>
            <Col className='distance' xs={3}>
              <strong>{distanceInKm}KM</strong>
            </Col>
          </Row>
          <Divider />
          <Col>
            <Col className='address'>
              <strong>{localize('pages.providers.search.results.card.address')}</strong>
              {providerData.address.addressLine1}, {providerData.address.city}, {providerData.address.province}, {providerData.address.postalCode}
            </Col>
            {providerData.phone && <Col className='phoneNumber'>
              <strong>{localize('pages.providers.search.results.card.phone')}</strong>
              <a href={phoneNumberLink}>{phoneNumber}</a>
            </Col>}
          </Col>
        </Grid>
      </Card>
    )
  }
}

export default ProvidersResultCard



// WEBPACK FOOTER //
// ./src/widgets/Providers/ProvidersResultCard.js